import $ from 'jquery';
import moment from 'moment';
import omsService from 'framework/services/omsService';
import sessionStorage from 'lib/session-storage';

function updatePrices(data) {
	$('[data-oms]').each((index, item)=> {
		var element = $(item);
		var clubId = element.data('oms-club');
		if(clubId) {
			var price = _.result(_.find(data.prices, (c)=> {
				return clubId === c.clubId;
			}), 'price');

			if(price) {
				element.text('Starting at ' + price.formattedValue + '/mo');
			}
		}
	});
}

function storePrices(data) {
	let obj = {
		date: moment().toISOString(),
		prices: data
	};
	sessionStorage.set('omsPrices', obj);
	updatePrices(obj);
}

function getOmsPricing() {
	omsService.api.getMinimumPricedProducts()
		.then(
			(data)=> {
				storePrices(data.productPrices);
			}
		);
}

export default updatePrices;

$(document).on('clubs-rendered', ()=> {
	var data = sessionStorage.get('omsPrices');
	if((data !== null && data !== 'undefined') && typeof data === 'object') {
		if(moment().subtract(1, 'm').isAfter(moment(data.date))) {
			getOmsPricing();
		} else{
			updatePrices(data);
		}
	} else{
		getOmsPricing();
	}
});
